import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { deviceTagFetcher } from '../../data/DeviceTag';
import type { DeviceTag } from '../../data/DeviceTag';
import { listDeviceFetcher, type Device } from '../../data/Device';
import { AxiosError } from 'axios';
import { Anchor, Breadcrumbs, Paper, Skeleton, Text } from '@mantine/core';

const DeviceTagDetail: React.FC = () => {
    const { deviceTagId } = useParams();
    const navigate = useNavigate();
    const {
        data: tag,
        isLoading,
        error,
    } = useSWR<DeviceTag, AxiosError>(deviceTagId ? `api/device-tag/${deviceTagId}` : null, deviceTagFetcher);

    const { data: devices, isLoading: devicesLoading } = useSWR<Device[], AxiosError>(
        deviceTagId ? `api/device-tag/${deviceTagId}/devices` : null,
        listDeviceFetcher
    );

    if (isLoading) return <Skeleton />;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <div>
            <Breadcrumbs separatorMargin="xs" separator={<Text size="sm" fw={500}>/</Text>}>
                <Anchor size="sm" fw={500} onClick={() => navigate('/')}>
                    Home
                </Anchor>
                <Anchor size="sm" fw={500} onClick={() => navigate('/device-tags')}>
                    Device tags
                </Anchor>
                <Text size="sm">{tag?.label}</Text>
            </Breadcrumbs>
            <h2>{tag?.label}</h2>
            <Text size="sm" fw={500} mt="md">
                Devices with this tag
            </Text>
            {devicesLoading ? (
                <Skeleton height={40} mt="sm" />
            ) : (
                devices?.map(d => (
                    <Paper key={d.id} shadow="xs" p="md" mt="sm">
                        <Anchor onClick={() => navigate(`/device/${d.id}`)}>{d.name}</Anchor>
                    </Paper>
                ))
            )}
        </div>
    );
};

export default DeviceTagDetail;
